<script setup>
// As ondas da gravação (A-13): uma barra por nível que o gravador leu (`niveis`, de 0 a 1, de
// `useGravadorDeAudio`), a mais nova à direita. É o que mostra, enquanto se fala, que o microfone
// está captando. Sem nível nenhum (o navegador sem AudioContext grava sem ondas), fica vazio.
//
// Mora em `shared/` porque a conversa de teste (a página do link e o Playground) e o widget usam o
// mesmo gravador. Sem texto: é desenho, e o leitor de tela o pula. A altura de cada barra é o único
// estilo em linha, porque muda a cada leitura; a cor é a do texto em volta (`bg-current`). Onde não
// cabem as 24, as mais velhas, à esquerda, ficam de fora.
defineProps({
  niveis: { type: Array, default: () => [] },
});

// A barra do silêncio ainda aparece, baixinha.
const altura = nivel => ({
  height: `${Math.max(12, Math.round(nivel * 100))}%`,
});
</script>

<template>
  <div
    class="flex items-center justify-end h-5 gap-0.5 overflow-hidden"
    aria-hidden="true"
    data-ondas
  >
    <span
      v-for="(nivel, i) in niveis"
      :key="i"
      class="w-0.5 shrink-0 rounded-full bg-current transition-[height] duration-100"
      :style="altura(nivel)"
    />
  </div>
</template>
